// import router from '@/router/index.js';
export const transactionProjectStatus = {
  methods: {
    defaultBtnText (status) {
      if ([10, 91].includes(status)) {
        return '编辑';
      } else if ([49, 51].includes(status)) {
        return '重新申请';
      } else if (status === 32) {
        return '确认公告';
      } else if (status === 41) {
        return '支付公告费';
      }
      // else if ([81, 84, 85, 86].includes(status)) {
      //   return '处理';
      // }
      else {
        return '';
      }
    },
    defaultBtnAction (item) {
      if ([10, 91].includes(item.status)) {
        if(item.id) {
          window.open(window.location.origin + '/#/publish-project/publisher-info?id=' + item.id);
        } else {
          window.open(window.location.origin + '/#/publish-project/publisher-info?id=' + item.projectId);
        }
      } else if ([49, 51].includes(item.status)) {
        if(item.id) {
          // window.open(window.location.origin + '/#/publish-project/publisher-info?oldId=' + item.id);
          this.$router.push('/publish-project/publisher-info?oldId=' + item.id);
        } else {
          window.open(window.location.origin + '/#/publish-project/publisher-info?oldId=' + item.projectId);
          this.$router.push('/publish-project/publisher-info?oldId=' + item.projectId);
        }
      } else if (item.status === 32) {
        this.confirmProjectById(item.id || item.projectId);
      } else if (item.status === 41) {
        this.currentProjectId = item.id || item.projectId;
        this.showPayment = true;
      }
      // else if ([81, 84, 85, 86].includes(item.status)) {
      //   router.push('/person-center/project/roll-out-project/trans?id=' + item.id);
      // }
    }
  }
};
